
// Contact form configuration
// Change the email here when needed
export const CONTACT_CONFIG = {
  // Current email for form submissions
  email: 'am@amming.de',
  
  // FormSubmit endpoint (automatically generated)
  get formSubmitEndpoint() {
    return `https://formsubmit.co/${this.email}`;
  },
  
  // Success redirect URL (optional - can be used for custom thank you page)
  successUrl: window.location.origin + '/kontakt?success=true',
  
  // Form settings
  settings: {
    // Disable FormSubmit's default captcha (we'll handle validation client-side)
    captcha: false,
    // Disable FormSubmit's autoresponse email
    autoresponse: false,
    // Custom subject line for emails
    subject: 'Neue Anfrage von AMMING Website',
  }
};
